import React, { useEffect } from "react";

// Components
import { Wrapper, Section, HeaderText, ProductTypeTag, DiscardButton, CreateProductButton } from "./Header.styles";
import { notification } from "antd";

// Helpers
import { objectToFormData } from "object-to-formdata";

// Hooks
import { useHistory, useParams } from "react-router";
import useProductCreateFlow from "../../../../hooks/reduxContainer/fulfillment/productCreateFlow";
import { useProductDetails, CreateProductBody } from "../../../../hooks/api/fulfillment/products";

// Interfaces
import { Product } from "../../../../interfaces/products";

const Header: React.FC = () => {
  const { product, dispatchResetProduct } = useProductCreateFlow();
  const { productDetails, createProduct } = useProductDetails();
  const history = useHistory();
  const params: { organization_id: string } = useParams();
  const organizationID = params.organization_id;
  const { loading, error } = productDetails;
  const { product_type, name, sku } = product;

  useEffect(() => {
    if (error)
      notification.error({
        message: "Error",
        description: error,
      });
  }, [error]);

  const validate = () => {
    if (!product_type || !name || !sku) return false;

    if (product_type === "base") {
      // TODO: validate packing details if any exist?
      // level exists, base_product_quantity > 0, sku_name.length > 0, weight, length, width, height all exist
      const { length, width, height, weight, cost, retail_price, return_days } = product;

      if (
        !length ||
        !width ||
        !height ||
        !weight ||
        cost === undefined ||
        return_days === undefined ||
        return_days === null ||
        !isFinite(cost) ||
        retail_price === undefined ||
        !isFinite(retail_price) ||
        retail_price <= 0
      ) {
        return false;
      }
    }

    if (product_type === "kit") {
      const { base_products, required_parts } = product;
      const validBaseProducts = base_products?.every((base) => required_parts && base && required_parts[base.id] > 0);

      if (!base_products?.length || !validBaseProducts) return false;
    }

    return true;
  };

  const ableToSubmit = validate();

  const handleOnSubmit = async () => {
    if (ableToSubmit) {
      const { product_type, image, packaging_levels } = product;

      const requestBody = {
        product: {
          ...product,
          organization_id: organizationID,
        },
      } as any;

      delete requestBody.product.image;
      if (image) requestBody.product.images_attributes = [{ file: image }];

      if (product_type === "kit") {
        const formDataBody = objectToFormData(requestBody as CreateProductBody);

        createProduct(formDataBody)
          .then((product: Product) => {
            history.push(`/organizations/${organizationID}/products/${product.id}`);
          })
          .catch(() => {});
      }

      if (product_type === "base") {
        const formattedPackingLevels = packaging_levels?.filter((packingLevel) => packingLevel.active);
        requestBody.product.packaging_levels_attributes = formattedPackingLevels;
        if (image) requestBody.product.images_attributes = [{ file: image }];
        const formDataBody = objectToFormData(requestBody);

        createProduct(formDataBody)
          .then((product: Product) => {
            history.push(`/organizations/${organizationID}/products/${product.id}`);
          })
          .catch(() => {});
      }
    }
  };

  return (
    <Wrapper>
      <Section>
        <HeaderText margin="0 8px 0 0">CREATING</HeaderText>
        <ProductTypeTag>{product_type === "kit" ? "VIRTUAL KIT" : "BASE PRODUCT"}</ProductTypeTag>
      </Section>
      <Section>
        <DiscardButton
          danger
          type="primary"
          onClick={() => {
            dispatchResetProduct();
            history.goBack();
          }}
        >
          DISCARD
        </DiscardButton>
        <CreateProductButton type="primary" disabled={!ableToSubmit} onClick={handleOnSubmit} loading={loading}>
          CREATE PRODUCT
        </CreateProductButton>
      </Section>
    </Wrapper>
  );
};

export default Header;
